import router from '@/router';
import { useAuthStore } from '@/stores/auth';
import { rememberReturnPath, sanitizeReturnPath } from '@/helpers/returnPath';

let redirecting = false;

/**
 * Leave the current screen for the login page immediately.
 * A full navigation is used because a router transition started from a
 * background timer can be cancelled, which leaves the old page on screen
 * until the next click.
 */
export function goToLogin(returnPath?: string) {
  if (redirecting || router.currentRoute.value.name === 'login') {
    return;
  }

  redirecting = true;

  const path = sanitizeReturnPath(returnPath) ?? sanitizeReturnPath(router.currentRoute.value.fullPath);

  if (path) {
    rememberReturnPath(path);
  }

  const authStore = useAuthStore();
  authStore.setUser(null);
  authStore.setLogged(false);
  authStore.setAgency(null);

  const href = router.resolve({
    name: 'login',
    query: path ? { redirect: path } : undefined,
  }).href;

  window.location.assign(href);

  window.setTimeout(() => {
    redirecting = false;
  }, 2000);
}
